export default __webpack_public_path__ + "static/media/lightningbolt.ac49aa2e.png";